import BaseModel from './baseModel'

export default class Collection extends BaseModel {

  sequences = {
    data: []
  }

  constructor (create, data) {
    super()
    if (create) {
      this.isNew = true
    }
    if (data !== undefined) {
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }

  prepareForSend () {
    return _.cloneDeep(this)
  }

  prepareQueryForSearch () {
    // this.anno_inizio = (this.range_anni[0] !== anno_inizio_def) ? this.range_anni[0] : null
    // this.anno_fine = (this.range_anni[1] !== anno_fine_def) ? this.range_anni[1] : null
    return super.prepareQueryForSearch(this)
  }
}



// WEBPACK FOOTER //
// ./src/models/collection.js